import { render } from "./BaseFile.vue?vue&type=template&id=2784e50c&scoped=true"
import script from "./BaseFile.vue?vue&type=script&lang=js"
export * from "./BaseFile.vue?vue&type=script&lang=js"

import "../../assets/css/inputeo.css?vue&type=style&index=0&id=2784e50c&scoped=true&lang=css"
import "./BaseFile.vue?vue&type=style&index=1&id=2784e50c&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2784e50c"]])

export default __exports__